import React from 'react'
import {ListGroup} from 'react-bootstrap'
import {ColorMaker} from "../../Configs/ColorMaker";

/**
 * Props interface for LegendList
 */
interface LegendListProps {
    /**
     * Array of color names to display (e.g. ['working', 'vacation', 'sick'])
     */
    items?: string[]

    /**
     * Function used for label translation (e.g. IntlMessageValue)
     */
    labelFn?: (lang: string, key: string, store: any) => string

    /**
     * Language code (default: 'de')
     */
    lang?: string

    /**
     * Optional translation store/context
     */
    store?: any

    /**
     * Optional font size for list items
     */
    fontSize?: string

    /**
     * optional class
     */
    className?: string
}

/**
 * LegendList component
 * Displays a horizontal list of legend items with color markers.
 */
export const LegendList: React.FC<LegendListProps> = ({
                                                          items = ['working', 'vacation', 'sick', 'unapologetic', 'absent', 'training', 'pause'],
                                                          labelFn,
                                                          lang = 'de',
                                                          store = null,
                                                          fontSize = '16px',
                                                          className = 'float-start mb-3',
                                                      }) => {
    return (
        <ListGroup horizontal className={className} id={"legend-list"} style={{fontSize}}>
            {items.map((item) => {
                const colorData = ColorMaker(item)
                const label = labelFn
                    ? labelFn(lang, `wtp.${item}`, store)
                    : item.charAt(0).toUpperCase() + item.slice(1)

                return (
                    <ListGroup.Item key={item}>
                        <span
                            className="LegendeColorHolder"
                            style={{
                                background: colorData.bg,
                            }}
                        ></span>
                        {label}
                    </ListGroup.Item>
                )
            })}
        </ListGroup>
    )
}
